import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/layout/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Documents from "@/pages/Documents";
import Templates from "@/pages/Templates";
import Marketplace from "@/pages/Marketplace";
import Generator from "@/pages/Generator";
import GeneratedDocs from "@/pages/GeneratedDocs";
import Skills from "@/pages/Skills";
import AISettings from "@/pages/AISettings";
import UsersPage from "@/pages/Users";
import SystemSettings from "@/pages/SystemSettings";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/documentos" element={<Documents />} />
              <Route
                path="/plantillas"
                element={<ProtectedRoute roles={["admin", "abogado"]}><Templates /></ProtectedRoute>}
              />
              <Route
                path="/marketplace"
                element={<ProtectedRoute roles={["admin", "abogado"]}><Marketplace /></ProtectedRoute>}
              />
              <Route
                path="/generador"
                element={<ProtectedRoute roles={["admin", "abogado"]}><Generator /></ProtectedRoute>}
              />
              <Route path="/documentos-generados" element={<GeneratedDocs />} />
              <Route
                path="/skills"
                element={<ProtectedRoute roles={["admin", "abogado"]}><Skills /></ProtectedRoute>}
              />
              <Route path="/ajustes-ia" element={<AISettings />} />
              <Route
                path="/usuarios"
                element={<ProtectedRoute roles={["admin"]}><UsersPage /></ProtectedRoute>}
              />
              <Route
                path="/ajustes-sistema"
                element={<ProtectedRoute roles={["admin"]}><SystemSettings /></ProtectedRoute>}
              />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
